<template>
    <div class="wh-wrap">
        <div class="wh-card" :class="{ off: !ts.on }">
            <div class="wh-head">
                <div class="wh-title">堂食营业时间</div>
                <div
                    class="wh-badge"
                    :class="{ off: !ts.on }"
                    @click.stop="toggleBiz('ts')"
                >{{ ts.on ? '开' : '关' }}</div>
            </div>
            <div class="wh-group-row wh-row">
                <span class="wh-group-label">工作日</span>
                <div class="wh-meal-times wh-group-times">
                    <span class="t" @click.stop="pick('ts_start')">{{ groupDisplay('ts', 'wd').start }}</span>
                    <i>-</i>
                    <span class="t" @click.stop="pick('ts_end')">{{ groupDisplay('ts', 'wd').end }}</span>
                </div>
            </div>
            <div class="wh-group-row wh-row">
                <span class="wh-group-label">周末</span>
                <div class="wh-meal-times wh-group-times">
                    <span class="t" @click.stop="pick('ts_start_we')">{{ groupDisplay('ts', 'we').start }}</span>
                    <i>-</i>
                    <span class="t" @click.stop="pick('ts_end_we')">{{ groupDisplay('ts', 'we').end }}</span>
                </div>
            </div>
            <div class="wh-chips">
                <span
                    class="wh-chip"
                    :class="{ on: isDayOn('ts', d.key) }"
                    v-for="d in days"
                    :key="'ts-' + d.key"
                    @click="toggleChannelDay('ts', d.key)"
                >{{ d.short }}</span>
            </div>
            <div class="wh-tip">工作日/周末分开设时段；点星期开关某天。总开关开时，未勾选的星期当天不营业</div>
        </div>

        <div class="wh-card" :class="{ off: !wm.on }">
            <div class="wh-head">
                <div class="wh-title">外卖配送时间</div>
                <div
                    class="wh-badge"
                    :class="{ off: !wm.on }"
                    @click.stop="toggleBiz('wm')"
                >{{ wm.on ? '开' : '关' }}</div>
            </div>
            <div class="wh-group-row wh-row">
                <span class="wh-group-label">工作日</span>
                <div class="wh-meal-times wh-group-times">
                    <span class="t" @click.stop="pick('wm_start')">{{ groupDisplay('wm', 'wd').start }}</span>
                    <i>-</i>
                    <span class="t" @click.stop="pick('wm_end')">{{ groupDisplay('wm', 'wd').end }}</span>
                </div>
            </div>
            <div class="wh-group-row wh-row">
                <span class="wh-group-label">周末</span>
                <div class="wh-meal-times wh-group-times">
                    <span class="t" @click.stop="pick('wm_start_we')">{{ groupDisplay('wm', 'we').start }}</span>
                    <i>-</i>
                    <span class="t" @click.stop="pick('wm_end_we')">{{ groupDisplay('wm', 'we').end }}</span>
                </div>
            </div>
            <div class="wh-chips">
                <span
                    class="wh-chip"
                    :class="{ on: isDayOn('wm', d.key) }"
                    v-for="d in days"
                    :key="'wm-' + d.key"
                    @click="toggleChannelDay('wm', d.key)"
                >{{ d.short }}</span>
            </div>
            <div class="wh-tip">工作日/周末分开设时段；点星期开关某天。总开关开时，未勾选的星期当天不营业</div>
        </div>

        <div class="wh-meals">
            <div
                class="wh-meal"
                :class="{ off: meal.on === false }"
                v-for="meal in mealList"
                :key="meal.key"
            >
                <div class="wh-meal-head">
                    <b>{{ meal.name }}</b>
                    <div
                        class="wh-badge"
                        :class="{ off: meal.on === false }"
                        @click="toggleMeal(meal.key)"
                    >{{ meal.on === false ? '关' : '开' }}</div>
                </div>
                <div class="wh-meal-times">
                    <span class="t" @click="pick(meal.key + '_start')">{{ meal.start }}</span>
                    <i>-</i>
                    <span class="t" @click="pick(meal.key + '_end')">{{ meal.end }}</span>
                </div>
                <div class="wh-chips">
                    <span
                        class="wh-chip"
                        :class="{ on: meal.days.indexOf(d.key) >= 0 }"
                        v-for="d in days"
                        :key="d.key"
                        @click="toggleDay(meal.key, d.key)"
                    >{{ d.short }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Notify } from 'vant'
import { getCookie } from '@/utils/auth'

const MEAL_KEYS = ['morning', 'in', 'afternoon', 'night']
const MEAL_NAMES = { morning: '早餐', in: '中餐', afternoon: '下午', night: '晚餐' }
const BIZ_DEFAULT = {
    ts: { on: true, start: '07:00', end: '22:00', start_we: '09:00', end_we: '22:00' },
    wm: { on: true, start: '07:00', end: '20:00', start_we: '10:00', end_we: '20:00' }
}
const MEAL_DEFAULT = {
    morning: { on: true, start: '07:00', end: '10:00', days: ['1', '2', '3', '4', '5'] },
    in: { on: true, start: '10:00', end: '13:00', days: ['1', '2', '3', '4', '5', '6', '7'] },
    afternoon: { on: true, start: '13:00', end: '18:00', days: ['1', '2', '3', '4', '5', '6', '7'] },
    night: { on: true, start: '17:00', end: '21:00', days: ['1', '2', '3', '4', '5', '6', '7'] }
}
const WD_DAYS = ['1', '2', '3', '4', '5']
const WE_DAYS = ['6', '7']

function padTime(v, fallback) {
    if (v === undefined || v === null || v === '') return fallback
    let s = String(v).trim()
    if (/^\d{2}:\d{2}:\d{2}$/.test(s)) s = s.slice(0, 5)
    if (/^\d{1}:\d{2}$/.test(s)) s = '0' + s
    if (/^\d{4}$/.test(s)) s = s.slice(0, 2) + ':' + s.slice(2)
    return /^\d{2}:\d{2}$/.test(s) ? s : fallback
}

function parseOn(v, fallback) {
    if (v === undefined || v === null || v === '') return fallback
    if (v === false || v === 0 || v === '0' || v === '关') return false
    if (v === true || v === 1 || v === '1' || v === '开') return true
    return !!v
}

function parseDays(v, fallback) {
    if (v === undefined || v === null || v === '') return fallback.slice()
    const out = []
    String(v).replace(/，/g, ',').split(',').forEach(part => {
        let d = parseInt(String(part).trim(), 10)
        if (d === 0) d = 7
        if (d >= 1 && d <= 7) out.push(String(d))
    })
    return out.length ? Array.from(new Set(out)) : fallback.slice()
}

function dayOn(entry) {
    if (!entry || typeof entry !== 'object') return false
    if (Object.prototype.hasOwnProperty.call(entry, 'on')) {
        return parseOn(entry.on, true)
    }
    return true
}

function parseWeek(raw) {
    if (!raw) return {}
    let data = raw
    if (typeof raw === 'string') {
        try {
            data = JSON.parse(raw)
        } catch (e) {
            return {}
        }
    }
    if (!data || typeof data !== 'object') return {}
    const out = {}
    Object.keys(data).forEach(k => {
        let d = parseInt(k, 10)
        if (d === 0) d = 7
        if (d < 1 || d > 7) return
        const v = data[k]
        if (!v || typeof v !== 'object') return
        out[String(d)] = {
            start: padTime(v.start, '07:00'),
            end: padTime(v.end, '22:00'),
            on: dayOn(v) ? 1 : 0
        }
    })
    return out
}

function weekFromLegacy(start, end, startWe, endWe, allOn) {
    const week = {}
    for (let d = 1; d <= 7; d++) {
        const we = d >= 6
        week[String(d)] = {
            start: we ? startWe : start,
            end: we ? endWe : end,
            on: allOn ? 1 : 0
        }
    }
    return week
}

function weekToObject(week) {
    const out = {}
    Object.keys(week || {}).forEach(k => {
        const e = week[k]
        if (!e) return
        if (!dayOn(e)) return
        out[k] = { start: e.start, end: e.end, on: 1 }
    })
    return out
}

function weekToJson(week) {
    return JSON.stringify(weekToObject(week))
}

function openDays(week) {
    return Object.keys(week || {}).filter(k => dayOn(week[k])).sort()
}

function openDaysIn(week, dayList) {
    return dayList.filter(k => dayOn(week[k]))
}

function cloneMeal(src) {
    return {
        on: src.on !== false,
        start: src.start,
        end: src.end,
        days: (src.days || []).slice()
    }
}

function cloneChannel(src) {
    return {
        on: !!src.on,
        week: parseWeek(JSON.stringify(src.week || {})),
        start: src.start || '07:00',
        end: src.end || '22:00',
        start_we: src.start_we || src.start || '09:00',
        end_we: src.end_we || src.end || '22:00'
    }
}

function isWeekendDay(day) {
    return day === '6' || day === '7' || Number(day) >= 6
}

export default {
    name: 'WeekHours',
    data() {
        return {
            days: [
                { key: '1', short: '一' },
                { key: '2', short: '二' },
                { key: '3', short: '三' },
                { key: '4', short: '四' },
                { key: '5', short: '五' },
                { key: '6', short: '六' },
                { key: '7', short: '日' }
            ],
            ts: cloneChannel({
                on: true,
                week: weekFromLegacy('07:00', '22:00', '09:00', '22:00', true),
                start: '07:00',
                end: '22:00',
                start_we: '09:00',
                end_we: '22:00'
            }),
            wm: cloneChannel({
                on: true,
                week: weekFromLegacy('07:00', '20:00', '10:00', '20:00', true),
                start: '07:00',
                end: '20:00',
                start_we: '10:00',
                end_we: '20:00'
            }),
            meals: {
                morning: cloneMeal(MEAL_DEFAULT.morning),
                in: cloneMeal(MEAL_DEFAULT.in),
                afternoon: cloneMeal(MEAL_DEFAULT.afternoon),
                night: cloneMeal(MEAL_DEFAULT.night)
            },
            loading: false
        }
    },
    computed: {
        mealList() {
            return MEAL_KEYS.map(key => ({
                key,
                name: MEAL_NAMES[key],
                ...this.meals[key]
            }))
        }
    },
    mounted() {
        this.loadFromApi()
    },
    methods: {
        shopId() {
            try {
                const shop = JSON.parse(getCookie('shop') || '{}')
                if (shop && shop.id) return shop.id
            } catch (e) { /* ignore */ }
            return localStorage.getItem('shop_id') || 0
        },
        storageKey() {
            return 'shop_week_hours_' + (this.shopId() || 'default')
        },
        /** group: 'wd' workday 1-5, 'we' weekend 6-7 */
        groupDisplay(ch, group) {
            const c = this[ch]
            const def = BIZ_DEFAULT[ch]
            const dayList = group === 'we' ? WE_DAYS : WD_DAYS
            const keys = openDaysIn(c.week, dayList)
            if (keys.length) {
                const first = c.week[keys[0]]
                return {
                    start: first.start || (group === 'we' ? c.start_we : c.start) || (group === 'we' ? def.start_we : def.start),
                    end: first.end || (group === 'we' ? c.end_we : c.end) || (group === 'we' ? def.end_we : def.end)
                }
            }
            if (group === 'we') {
                return {
                    start: c.start_we || def.start_we,
                    end: c.end_we || def.end_we
                }
            }
            return {
                start: c.start || def.start,
                end: c.end || def.end
            }
        },
        /** @deprecated kept for any parent that still calls it — returns workday display */
        channelDisplay(ch) {
            return this.groupDisplay(ch, 'wd')
        },
        isDayOn(ch, day) {
            return dayOn(this[ch].week[day])
        },
        syncGroupCache(ch) {
            const c = this[ch]
            const wd = this.groupDisplay(ch, 'wd')
            const we = this.groupDisplay(ch, 'we')
            c.start = wd.start
            c.end = wd.end
            c.start_we = we.start
            c.end_we = we.end
        },
        loadFromApi() {
            const id = this.shopId()
            this.loading = true
            const infoReq = this.$API.applyInfo({ id }).catch(() => null)
            const hoursReq = this.$API.shopHours().catch(() => null)
            Promise.all([infoReq, hoursReq]).then(([infoRes, hoursRes]) => {
                let ok = false
                if (infoRes && infoRes.data) {
                    this.applyBiz(infoRes.data)
                    ok = true
                }
                if (hoursRes && hoursRes.data) {
                    this.applyMeals(hoursRes.data)
                    ok = true
                }
                if (ok) {
                    this.persistCache()
                } else {
                    this.loadCacheFallback()
                }
            }).finally(() => {
                this.loading = false
            })
        },
        applyBiz(data) {
            var channels = ['ts', 'wm']
            channels.forEach(ch => {
                const def = BIZ_DEFAULT[ch]
                const on = parseOn(data[ch + '_switch'], true)
                const start = padTime(data[ch + '_start'], def.start)
                const end = padTime(data[ch + '_end'], def.end)
                const startWe = padTime(data[ch + '_start_we'] || data[ch + '_start'], def.start_we)
                const endWe = padTime(data[ch + '_end_we'] || data[ch + '_end'], def.end_we)
                let week = parseWeek(data[ch + '_week'])
                if (!Object.keys(week).length) {
                    week = weekFromLegacy(start, end, startWe, endWe, true)
                }
                this[ch] = {
                    on,
                    week,
                    start,
                    end,
                    start_we: startWe,
                    end_we: endWe
                }
                this.syncGroupCache(ch)
            })
        },
        applyMeals(data) {
            MEAL_KEYS.forEach(key => {
                const def = MEAL_DEFAULT[key]
                this.meals[key] = {
                    on: parseOn(data[key + '_on'], def.on),
                    start: padTime(data[key + '_start_time'], def.start),
                    end: padTime(data[key + '_end_time'], def.end),
                    days: parseDays(data[key + '_days'], def.days)
                }
            })
        },
        persistCache() {
            try {
                localStorage.setItem(this.storageKey(), JSON.stringify({
                    ts: this.ts,
                    wm: this.wm,
                    meals: this.meals
                }))
            } catch (e) { /* ignore */ }
        },
        loadCacheFallback() {
            try {
                const saved = JSON.parse(localStorage.getItem(this.storageKey()) || '{}')
                var channels = ['ts', 'wm']
                channels.forEach(ch => {
                    if (saved[ch]) {
                        if (saved[ch].week) {
                            this[ch] = cloneChannel(saved[ch])
                            this.syncGroupCache(ch)
                        } else {
                            const start = saved[ch].start || BIZ_DEFAULT[ch].start
                            const end = saved[ch].end || BIZ_DEFAULT[ch].end
                            const startWe = saved[ch].start_we || start
                            const endWe = saved[ch].end_we || end
                            this[ch] = {
                                on: saved[ch].on !== false,
                                week: weekFromLegacy(start, end, startWe, endWe, true),
                                start,
                                end,
                                start_we: startWe,
                                end_we: endWe
                            }
                        }
                    }
                })
                if (saved.meals) {
                    MEAL_KEYS.forEach(key => {
                        if (saved.meals[key]) {
                            this.meals[key] = Object.assign(cloneMeal(MEAL_DEFAULT[key]), saved.meals[key])
                        }
                    })
                } else {
                    MEAL_KEYS.forEach(key => {
                        if (saved[key]) {
                            this.meals[key] = Object.assign(cloneMeal(MEAL_DEFAULT[key]), saved[key])
                        }
                    })
                }
            } catch (e) { /* ignore */ }
        },
        getField(type) {
            if (type === 'ts_start') return this.groupDisplay('ts', 'wd').start
            if (type === 'ts_end') return this.groupDisplay('ts', 'wd').end
            if (type === 'ts_start_we') return this.groupDisplay('ts', 'we').start
            if (type === 'ts_end_we') return this.groupDisplay('ts', 'we').end
            if (type === 'wm_start') return this.groupDisplay('wm', 'wd').start
            if (type === 'wm_end') return this.groupDisplay('wm', 'wd').end
            if (type === 'wm_start_we') return this.groupDisplay('wm', 'we').start
            if (type === 'wm_end_we') return this.groupDisplay('wm', 'we').end
            const m = type.match(/^(morning|in|afternoon|night)_(start|end)$/)
            if (m) {
                return m[2] === 'start' ? this.meals[m[1]].start : this.meals[m[1]].end
            }
            return ''
        },
        /**
         * Apply a time change only to currently-ON days in workday {1-5} or weekend {6-7}.
         * Does not force-select other days in the group. Returns week JSON payload for parent save.
         */
        buildChannelWeekSave(type, value) {
            const m = String(type).match(/^(ts|wm)_(start|end)(_we)?$/)
            if (!m) return null
            const ch = m[1]
            const field = m[2]
            const isWe = !!m[3]
            const group = isWe ? 'we' : 'wd'
            const dayList = isWe ? WE_DAYS : WD_DAYS
            const v = padTime(value, value)
            const c = this[ch]
            let keys = openDaysIn(c.week, dayList)

            if (!keys.length) {
                // no days currently ON in this group — only update display cache;
                // do NOT force-select all Mon–Fri or both Sat–Sun
                if (isWe) {
                    if (field === 'start') c.start_we = v
                    else c.end_we = v
                } else {
                    if (field === 'start') c.start = v
                    else c.end = v
                }
                this.persistCache()
                return { type: ch + '_week', value: weekToJson(c.week) }
            }

            // apply ONLY to currently-ON days in this group (free subset, e.g. 一三五)
            keys.forEach(k => {
                if (!c.week[k]) {
                    const disp = this.groupDisplay(ch, group)
                    c.week[k] = { start: disp.start, end: disp.end, on: 1 }
                }
                c.week[k][field] = v
            })

            this.syncGroupCache(ch)
            this.persistCache()
            return { type: ch + '_week', value: weekToJson(c.week) }
        },
        applySaved(type, value) {
            const v = padTime(value, value)
            if (/^(ts|wm)_(start|end)(_we)?$/.test(type)) {
                this.buildChannelWeekSave(type, v)
                return
            }
            const m = type.match(/^(morning|in|afternoon|night)_(start|end)$/)
            if (m) {
                if (m[2] === 'start') this.meals[m[1]].start = v
                else this.meals[m[1]].end = v
            }
            this.persistCache()
        },
        applyWeekSaved(ch, jsonValue) {
            const week = parseWeek(jsonValue)
            this[ch].week = week
            this.syncGroupCache(ch)
            this.persistCache()
        },
        /**
         * Map a start/end field tap to a paired range for the parent dual picker.
         * Tapping either side of a pair opens the same popup with both times.
         */
        resolvePair(type) {
            const map = {
                ts_start: ['channel', 'ts_start', 'ts_end'],
                ts_end: ['channel', 'ts_start', 'ts_end'],
                ts_start_we: ['channel', 'ts_start_we', 'ts_end_we'],
                ts_end_we: ['channel', 'ts_start_we', 'ts_end_we'],
                wm_start: ['channel', 'wm_start', 'wm_end'],
                wm_end: ['channel', 'wm_start', 'wm_end'],
                wm_start_we: ['channel', 'wm_start_we', 'wm_end_we'],
                wm_end_we: ['channel', 'wm_start_we', 'wm_end_we'],
                morning_start: ['meal', 'morning_start', 'morning_end'],
                morning_end: ['meal', 'morning_start', 'morning_end'],
                in_start: ['meal', 'in_start', 'in_end'],
                in_end: ['meal', 'in_start', 'in_end'],
                afternoon_start: ['meal', 'afternoon_start', 'afternoon_end'],
                afternoon_end: ['meal', 'afternoon_start', 'afternoon_end'],
                night_start: ['meal', 'night_start', 'night_end'],
                night_end: ['meal', 'night_start', 'night_end']
            }
            const row = map[type]
            if (!row) return null
            return {
                kind: row[0],
                startType: row[1],
                endType: row[2],
                start: this.getField(row[1]),
                end: this.getField(row[2])
            }
        },
        pick(type) {
            const pair = this.resolvePair(type)
            if (pair) {
                this.$emit('pick-range', pair)
                return
            }
            this.$emit('pick-time', type, this.getField(type))
        },
        /** Apply both start+end to a channel group; returns {type,value} week payload. */
        buildChannelWeekRangeSave(startType, endType, startVal, endVal) {
            this.buildChannelWeekSave(startType, startVal)
            return this.buildChannelWeekSave(endType, endVal)
        },
        saveChannelWeek(ch) {
            // 传对象，避免 JSON 字符串被服务端 htmlspecialchars 弄坏
            const payload = { type: ch + '_week', value: weekToObject(this[ch].week) }
            return this.$API.shopEditHours(payload).then((res) => {
                if (res && res.data) {
                    this.applyBiz(res.data)
                }
                this.persistCache()
                Notify({ type: 'success', message: '设置成功' })
            }).catch(() => {
                Notify({ type: 'danger', message: '设置失败' })
                throw new Error('save fail')
            })
        },
        toggleBiz(type) {
            const next = !this[type].on
            const key = type === 'ts' ? 'ts_switch' : 'wm_switch'
            const payload = {}
            payload[key] = next ? '1' : '0'
            this.$API.shopEdit(payload).then(() => {
                this[type].on = next
                this.persistCache()
                Notify({ type: 'success', message: '设置成功' })
            }).catch(() => {
                Notify({ type: 'danger', message: '设置失败' })
            })
        },
        toggleChannelDay(ch, day) {
            // Uncheck → on:0 then omit from JSON; immediately persist via shopEditHours
            const week = Object.assign({}, this[ch].week)
            if (dayOn(week[day])) {
                const keys = openDays(week)
                if (keys.length <= 1) {
                    Notify({ type: 'warning', message: '至少保留一天' })
                    return
                }
                // mark closed then drop key so weekToJson omits the day (server: 今日不营业)
                week[day] = Object.assign({}, week[day], { on: 0 })
                delete week[day]
            } else {
                const group = isWeekendDay(day) ? 'we' : 'wd'
                const disp = this.groupDisplay(ch, group)
                week[day] = { start: disp.start, end: disp.end, on: 1 }
            }
            this[ch].week = week
            this.syncGroupCache(ch)
            this.persistCache()
            this.saveChannelWeek(ch).catch(() => {
                this.loadFromApi()
            })
            this.$emit('channel-week-saved', ch, weekToJson(this[ch].week))
        },
        toggleMeal(key) {
            const nextOn = !(this.meals[key].on !== false)
            const value = nextOn ? '1' : '0'
            this.$API.shopHoursEdit({ type: key + '_on', value }).then(() => {
                this.meals[key].on = nextOn
                this.persistCache()
                Notify({ type: 'success', message: '设置成功' })
            }).catch(() => {
                Notify({ type: 'danger', message: '设置失败' })
            })
        },
        toggleDay(key, day) {
            const arr = (this.meals[key].days || []).slice()
            const i = arr.indexOf(day)
            if (i >= 0) {
                if (arr.length <= 1) {
                    Notify({ type: 'warning', message: '至少保留一天' })
                    return
                }
                arr.splice(i, 1)
            } else {
                arr.push(day)
            }
            arr.sort()
            const value = arr.join(',')
            this.$API.shopHoursEdit({ type: key + '_days', value }).then(() => {
                this.meals[key].days = arr
                this.persistCache()
                Notify({ type: 'success', message: '设置成功' })
            }).catch(() => {
                Notify({ type: 'danger', message: '设置失败' })
            })
        }
    }
}
</script>

<style lang="less" scoped>
/* sizes tuned for phone; shop-ui.css further polishes .wh-* with !important */
.wh-wrap {
    padding: 0 4px 8px;
}
.wh-card {
    background: #fff;
    border-radius: 12px;
    padding: 10px 12px 8px;
    margin-bottom: 8px;
    box-shadow: 0 4px 14px rgba(39, 37, 31, 0.08);
    &.off {
        opacity: 0.72;
    }
}
.wh-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
}
.wh-title {
    font-size: 15px;
    font-weight: 800;
    color: #27251f;
}
.wh-badge {
    min-width: 40px;
    text-align: center;
    background: #3cb371;
    color: #fff;
    border-radius: 8px;
    padding: 2px 10px;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.4;
    &.off {
        background: #27251f;
    }
}
.wh-group-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 4px 0;
}
.wh-group-label {
    font-size: 13px;
    color: #666;
    font-weight: 700;
    min-width: 48px;
    text-align: right;
    flex-shrink: 0;
}
.wh-group-times {
    margin: 0 !important;
    flex: 1;
    text-align: left;
}
.wh-tip {
    font-size: 11px;
    color: #999;
    margin-top: 6px;
    text-align: center;
    line-height: 1.35;
}
.wh-meals {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.wh-meal {
    width: calc(50% - 4px);
    box-sizing: border-box;
    background: #fff;
    border-radius: 12px;
    padding: 10px 8px;
    box-shadow: 0 4px 14px rgba(39, 37, 31, 0.08);
    &.off {
        opacity: 0.7;
    }
}
.wh-meal-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
}
.wh-meal-times {
    text-align: center;
    color: #3cb371;
    font-size: 15px;
    font-weight: 800;
    margin: 6px 0 6px;
    span {
        padding: 1px 2px;
    }
    i {
        font-style: normal;
        color: #999;
        margin: 0 2px;
        font-weight: 400;
    }
}
.wh-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
}
.wh-chip {
    background: #f4f4f4;
    border-radius: 8px;
    padding: 2px 7px;
    font-size: 12px;
    color: #27251f;
    &.on {
        background: #ffc72c;
        color: #27251f;
        font-weight: 700;
    }
}
</style>
